import { Icon, IconProps } from './Icon';

export const SmartToolsFlightDelayPredictionIcon = ({ ...props }: IconProps) => (
  <Icon
    {...props}
    viewBox="0 0 25 24"
  >
    <path
      d="M13.0867 4.32204L11.1331 7.35041C11.0906 7.41666 11.0318 7.47098 10.9625 7.50823C10.8931 7.54548 10.8154 7.56443 10.7367 7.56331L3.96633 7.46608C3.88786 7.46495 3.8104 7.48378 3.7412 7.52079C3.67199 7.5578 3.61333 7.61178 3.5707 7.67767L3.19397 8.26167C3.15578 8.32087 3.13159 8.38799 3.12324 8.45793C3.1149 8.52788 3.12261 8.59881 3.14579 8.66533C3.16897 8.73185 3.20702 8.7922 3.25703 8.84181C3.30705 8.89141 3.36772 8.92896 3.43443 8.95159L8.33887 10.6194C8.40557 10.642 8.46624 10.6796 8.51626 10.7292C8.56627 10.7788 8.60432 10.8391 8.6275 10.9056C8.65069 10.9722 8.6584 11.0431 8.65005 11.113C8.6417 11.183 8.61751 11.2501 8.57932 11.3093L7.3403 13.23C7.30448 13.2854 7.25724 13.3325 7.20174 13.3682C7.14624 13.4039 7.08377 13.4273 7.01849 13.4368L4.82576 13.7591C4.36029 13.8282 4.28102 14.4654 4.71533 14.6454L7.0755 15.6248C7.12679 15.6461 7.17382 15.6764 7.21437 15.7144L9.07977 17.4608C9.42241 17.7829 9.9706 17.4474 9.84126 16.9954L9.23079 14.8649C9.21257 14.8013 9.20815 14.7346 9.21784 14.6692C9.22753 14.6039 9.2511 14.5413 9.28697 14.4858L10.526 12.5651C10.5642 12.5059 10.6153 12.4563 10.6755 12.4199C10.7357 12.3835 10.8034 12.3613 10.8735 12.3549C10.9435 12.3486 11.0141 12.3583 11.0799 12.3833C11.1457 12.4083 11.2049 12.448 11.253 12.4993L14.7958 16.2807C14.844 16.332 14.9032 16.3716 14.969 16.3966C15.0347 16.4216 15.1053 16.4313 15.1754 16.425C15.2455 16.4186 15.3132 16.3964 15.3734 16.36C15.4336 16.3236 15.4847 16.274 15.5229 16.2148L15.8996 15.6308C15.9421 15.5648 15.9671 15.4891 15.9723 15.4108C15.9774 15.3325 15.9626 15.2542 15.9293 15.1832L13.0497 9.0545C13.0163 8.98336 13.0015 8.90488 13.0068 8.82645C13.012 8.74802 13.0372 8.67222 13.0798 8.60618L15.0333 5.57781C15.1999 5.31966 15.257 5.00594 15.1922 4.70565C15.1275 4.40537 14.946 4.14311 14.6879 3.97659C14.4298 3.81006 14.116 3.75291 13.8157 3.81769C13.5155 3.88248 13.2532 4.0639 13.0867 4.32204Z"
      stroke="#222B3A"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M21.4264 20L19.3857 19.0492V17"
      stroke="#222B3A"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M22.2718 16.1716C23.8656 17.7337 23.8656 20.2663 22.2718 21.8284C20.6779 23.3905 18.0939 23.3905 16.5001 21.8284C14.9062 20.2663 14.9062 17.7337 16.5001 16.1716C18.0939 14.6095 20.678 14.6095 22.2718 16.1716"
      stroke="#222B3A"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </Icon>
);
